// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2378":"96e26aca810070d5","6866":"942476ed2ac0e886","8777":"bdb4b157217b5969"}[chunkId] + ".js";
};